/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["appearance-color-input{display:block}appearance-color-input>.color-picker-container{flex:1 1 auto;display:flex;align-items:center;overflow:hidden}appearance-color-input .color-icon{width:35px;height:35px}appearance-color-input .name{margin-left:3px;margin-top:3px;font-size:1.4rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:160px}appearance-color-input .change{color:#1565c0;font-size:1.3rem;margin-left:auto}"];
export { styles as styles };
